export const daysFullLoklaiseKeys = { Sunday: 'sunday',
  Monday: 'monday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday',
  Thursday: 'thursday',
  Friday: 'friday',
  Saturday: 'saturday' };

export const daysShortLoklaiseKeys = { Sun: 'sun',
  Mon: 'mon',
  Tue: 'tue',
  Wed: 'wed',
  Thu: 'thu',
  Fri: 'fri',
  Sat: 'sat' };

export const monthsFullLokaliseKeys = {
  January: 'january',
  February: 'february',
  March: 'march',
  April: 'april',
  May: 'may',
  June: 'june',
  July: 'july',
  August: 'august',
  September: 'september',
  October: 'october',
  November: 'november',
  December: 'december'
};
export const monthsShortLokaliseKeys = { Jan: 'jan',
  Feb: 'feb',
  Mar: 'mar',
  Apr: 'apr',
  May: 'may',
  Jun: 'jun',
  Jul: 'jul',
  Aug: 'aug',
  Sep: 'sep',
  Oct: 'oct',
  Nov: 'nov',
  Dec: 'dec' };

export const alignerSetButtonTypes = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
  FUTURE: 'future',
  FUTURE_MANDATORY_REVIEW: 'future-mandatory-review',
  FUTURE_EOT: 'future-eot'
};

export const appointmentCardTheme = {
  RED: 'red-border',
  GREEN: 'green-border',
  BLUE: 'blue-border',
  GRAY: 'gray-border'
};

export const appointmentCardTypes = {
  DEFAULT: 'DEFAULT',
  NO_SHOW_VISIT_OVERDUE: 'NO_SHOW_VISIT_OVERDUE',
  VISIT_OVERDUE: 'VISIT_OVERDUE',
  NOT_SCHEDULED: 'NOT_SCHEDULED',
  SCHEDULED: 'SCHEDULED',
  CONFIRMATION: 'CONFIRMATION',
  CONFIRMED_BY_CLINIC: 'CONFIRMED_BY_CLINIC',
  COMPLETED: 'COMPLETED',
  NO_SHOW: 'NO_SHOW',
  NO_SHOW_RESCHEDULED: 'NO_SHOW_RESCHEDULED'
};

export const appointmentTitleMapping = {
  FITTING: 'fitting',
  RE_SCAN: 're_scan',
  ADD_ATTACHMENT: 'add_attachment',
  REMOVE_ATTACHMENT: 'remove_attachment',
  IPR_STAGE: 'ipr_stage',
  REVIEW_100: 'review_100',
  MID_REVIEW: 'mid_review',
  EXTRACTION: 'extraction',
  ADD_BUTTON: 'add_button',
  REMOVE_BUTTON: 'remove_button',
  RE_CHECK: 're_check',
  SCAN: 'scan',
  CONSULTATION: 'consultation',
  PERSONAL: 'personal'
};

export const appointmentTypes = {
  FITTING: 'FITTING',
  IPR_STAGE: 'IPR_STAGE',
  REVIEW_100: 'REVIEW_100',
  MID_REVIEW: 'MID_REVIEW',
  EXTRACTION: 'EXTRACTION',
  RE_SCAN: 'RE_SCAN',
  RE_CHECK: 'RE_CHECK',
  SCAN: 'SCAN'
};

export const appointmentTypeDetailsKeys = {
  IPR_STAGE: 'ipr_type_details',
  MID_REVIEW: 'mid_review_type_details'
};

export const warningStatuses = [appointmentCardTypes.NO_SHOW_VISIT_OVERDUE,
  appointmentCardTypes.VISIT_OVERDUE, appointmentCardTypes.NOT_SCHEDULED];

export const cautionStatuses = [appointmentCardTypes.CONFIRMED_BY_CLINIC];

export const intercomDisabledPages = ['login', 'camera', 'sales', 'treatment-plan-sales', 'smartee'];
export const whatsappEnabledPages = ['sales', 'treatment-plan-sales'];

export const preTreatmentStages = ['PENDING', 'ALIGNERS_ORDERED'];

export const excludedTreatmentStatuses = ['INITIATED'];

export const treatmentTypes = {
  REFINEMENT: 'refinement',
  AFTER_SALES: 'aftersales'
};

export const setAppointmentTypes = ['IPR_STAGE', 'ADD_ATTACHMENT', 'REMOVE_ATTACHMENT',
  'ADD_BUTTON', 'REMOVE_BUTTON', 'REVIEW_100'];

export const treatmentKeysConfig = {
  MY_TREATMENT: 'my_treatment',
  REFINEMENT_INFO: 'refinement_info',
  REFINEMENT: 'refinement',
  AFTER_SALES: 'AFTER_SALES'
};

export const RETAINER_KEY = 'retainer';

export const otpModalHeading = {
  LOGIN: 'login_page.enter_otp',
  TREATMENT_PLAN: 'login_page.confirm_approval'
};

export const PRE_IN_PROGRESS_STATUSES = [
  'INITIATED', 'WAITING_TPV_APPROVAL', 'TPV_APPROVED', 'ALIGNERS_ORDERED', 'PENDING'
];

export const RETAINER_PAYMENT_STATUSES = {
  PAYMENT_DUE: 'PaymentDue',
  IN_PROGRESS: 'InProgress',
  PAID: 'Paid',
  FAILED: 'Failed'
};

export const TPV_SECTIONS_DESKTOP = [
  'summary',
  'limitations',
  'risks',
  'guidelines'
];

export const TPV_SECTIONS_MOBILE = [
  '3d_Model',
  'summary',
  'limitations',
  'risks',
  'guidelines',
  'approval'
];

export const ZENYUM_WHATSAPP = 'https://wa.me/6589073136';

export const ZENYUM_ONELINK_BASE_URL = 'https://zenyum.onelink.me/4taf';

export const ZENYUM_ONELINK_URLS = {
  PHOTO_MODULE: `${ZENYUM_ONELINK_BASE_URL}?af_xp=social&pid=flight_path&deep_link_value=photo_module&deep_link_sub1=from_flightpath`,
  getReferralDeepLink: (userId) => `${ZENYUM_ONELINK_BASE_URL}?pid=QR_code&c=Referrals&af_dp=zenyum%3A%2F%2F&deep_link_value=referral-userId=${userId}`,
  getYourJourneyDeepLink: (userId) => `${ZENYUM_ONELINK_BASE_URL}?pid=Email&deep_link_value=your-journey-userId=${userId}&af_dp=zenyum%3A%2F%2F`
};

export const ZENYUM_CHAT_LINKS = {
  TREATMENT_PLAN: {
    'tw-zh': 'https://line.me/R/oaMessage/@422rxkkf/?我有治療計畫疑問',
    'tw-en': 'https://line.me/R/oaMessage/@422rxkkf/?I%20have%20questions%20about%20my%20treatment%20plan',
    'sg-en': 'https://wa.me/message/RDAQA4VX6UHDO1',
    'hk-zh': 'https://wa.me/message/CCU43VLOWKS5K1',
    'hk-en': 'https://wa.me/message/ORFYSCMK5ORAN1',
    'jp-ja': 'https://line.me/R/oaMessage/@563qrlaq/?I%20have%20questions%20about%20my%20treatment%20plan'
  },
  TALK_TO_US: {
    'tw-zh': 'https://line.me/R/oaMessage/@422rxkkf/?聯繫微笑專員',
    'tw-en': 'https://line.me/R/oaMessage/@422rxkkf/?I%20want%20to%20contact%20agent',
    'sg-en': 'https://wa.me/message/A2SXYQPRH4OJK1',
    'hk-zh': 'https://wa.me/message/NHOLA74KEWWYO1',
    'hk-en': 'https://wa.me/message/224TR6XQCEUDA1',
    'jp-ja': 'https://line.me/R/oaMessage/@563qrlaq/?I%20want%20to%20contact%20agent'
  },
  LOST_PAGE: {
    'tw-zh': 'https://line.me/R/oaMessage/@422rxkkf/?我想繼續了解隱形牙套',
    'tw-en': 'https://line.me/R/oaMessage/@422rxkkf/?I%20want%20to%20learn%20more%20about%20Zenyum%20Invisible%20Braces',
    'sg-en': 'https://wa.me/message/PBYXQU6IIOEQA1',
    'hk-zh': 'https://wa.me/message/NHOLA74KEWWYO1',
    'hk-en': 'https://wa.me/message/224TR6XQCEUDA1',
    'jp-ja': 'https://line.me/R/oaMessage/@563qrlaq/?I%20want%20to%20learn%20more%20about%20Zenyum%20Invisible%20Braces'
  }
};
